import formatter from './tooltipFormatter';
import { toEchartData } from '../dataProcessor';
import { round } from '../../../../../util/numbers/rounder';
import { capitalizeText } from 'src/util/formatters/stringNormalizer';

/**
 * converte os resultados gerais passados (data)
 * para a option do echarts.
 * @param {*} data resultados gerais
 * @param {*} theme tema atual, é utilizado para definir
 * cores das legendas, barras, fonte, etc.
 */
export default function toEchartOption(data, theme, chartFontSize = 14, disabledLegends) {
  /**
   * parsing to intermediary data structure
   * it will extract, from data, legends and series.
   */
  const echartData = toEchartData(data);
  const { legends, data: resultData } = echartData;

  const selectedLegends = {};
  const legendsWithIcon = echartData.legends.map((legend) => {
    selectedLegends[legend] = !disabledLegends.includes(legend);
    return {
      name: legend,
      icon: 'circle',
    };
  });
  

  /**
   * Refere-se a um sub-pergunta da pergunta do tipo grade
   */
  const lines = [...new Set(resultData.map((value) => value.label).reverse())];

  /**
    * Tratando os dados para ficar de forma reverse e ordenado de acordo com:
    * 1. linhas do gráfico
    * 2. legenda do gráfico
    */
  const seriesData = resultData.reverse()
    .sort((a, b) => {
      if (lines.indexOf(a.label) < lines.indexOf(b.label)) return -1;
      if (lines.indexOf(a.label) > lines.indexOf(b.label)) return 1;
      return 0;
    })
    .sort((a, b) => {
      if (legends.indexOf(a.name) < legends.indexOf(b.name)) return -1;
      if (legends.indexOf(a.name) > legends.indexOf(b.name)) return 1;
      return 0;
    });

  const series = [];
  const pairs = [];
  const iterations = [];
  const subtitles = [];

  seriesData.forEach((serie) => {
    if (iterations.indexOf(serie.label) >= 0) {
      return;
    }
    const pairResult = seriesData.filter((c) => c.label === serie.label);

    if (pairResult.length) {
      pairs.push(pairResult);
      iterations.push(serie.label);
    }
  });

  pairs.reverse().forEach((pair, index) => {
    /**
      * Recuperando valores apenas para o par do index desejado
      */
    const valuesFromLine = pair
      .map((value) => ({ name: value.name, value: value.value, numeric: value.numeric }));

    /**
      * As séries são criadas de acordo com o par
      */
    const pieRadius = (100 / pairs.length) - (25 / pairs.length);
    const pieLeft = (50 / pairs.length) + index * (100 / pairs.length);

    series.push({
      type: 'pie',
      radius: `${pieRadius}%`,
      avoidLabelOverlap: true,
      label: {
        show: true,
        textStyle: {
          fontSize: chartFontSize,
          color: theme.label.text,
        },
        formatter: (params) => (`${round(params.value, 1)}%`),
      },
      labelLine: {
        show: true,
        lineStyle: {
          color: theme.label.line,
        },
      },
      emphasis: {
        focus: 'series',
      },
      minShowLabelAngle: 5,
      data: valuesFromLine,
      center: [`${pieLeft}%`, '50%'],
    });

    subtitles.push({
      subtext: pair[0].label,
      left: `${pieLeft}%`,
      top: '90%',
      textAlign: 'center',
      subtextStyle: {
        color: theme.legend.color,
        fontSize: chartFontSize,
      },
    });
  });

  const tooltipFormatter = (item) => {
    const output = `${item.marker} ${item.name}: ${item.data.numeric} (${item.data.value}%)`;
    const title = pairs[item.seriesIndex][0].label;
    return `${title}<br>${output}`;
  };

  return {
    title: subtitles,
    animationDuration: 0,
    color: theme.colors,
    visibleLegends: legendsWithIcon,
    tooltip: {
      trigger: 'item',
      axisPointer: {
        type: 'shadow',
      },
      formatter: tooltipFormatter,
    },
    legend: {
      selected: selectedLegends,
      orient: 'horizontal',
      x: 'left',
      data: legendsWithIcon,
      type: 'scroll',
      textStyle: {
        width: '10%',
        color: theme.legend.color,
        fontSize: chartFontSize,
        fontFamily: 'Roboto, sans-serif'
      },
      formatter: capitalizeText,
      pageTextStyle: {
        color: theme.legend.pagination.text.color,
      },
      pageIconColor: theme.legend.pagination.buttons.color,
    },
    series,
  };
}
